var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yes-no-dialog',{attrs:{"value":_vm.value,"title":"Really delete?","text":_vm.text,"width":"310"},on:{"input":function($event){return _vm.$emit('input', $event)},"yes":function($event){return _vm.$emit('yes')},"no":function($event){return _vm.$emit('no')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }